<template>
                    
                           
<section class="reset-password" :style="{
    'background-image': 'url(' + backgroundImage + ')'
  }">
  <header-logged-out type="teacher" :checkuser="false"></header-logged-out>
  <v-container fill-height>
    <v-row class="fill-height" align="center" justify="center">
      <v-col cols="12" sm="10" md="8" lg="6" xl="4">
        <v-card>
          <v-toolbar dark color="primary" flat>
            <v-toolbar-title>{{ label }} Reset Password</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <form>
              <v-text-field ref="password" v-model="password" name="password" label="Enter your password" hint="Make sure your password is 6 to 20 characters long" min="6" :append-icon="visible ? 'visibility' : 'visibility_off'" @click:append="visible = !visible" :error-messages="errors.collect('password')" v-validate="'required|min:6|max:20'" data-vv-name="password" required :type="visible ? 'text' : 'password'"></v-text-field>
              <v-text-field v-model="password_confirmation" name="password_confirmation" label="Confirm your password" min="6" :append-icon="visible ? 'visibility' : 'visibility_off'" @click:append="visible = !visible" :error-messages="errors.collect('password_confirmation')" v-validate="'required|confirmed:password'" data-vv-name="password_confirmation" required :type="visible ? 'text' : 'password'"></v-text-field>
            </form>
          </v-card-text>
          <v-card-actions class="px-3 pb-3 pt-0">
            <v-btn color="primary" @click="submit" :loading="loading" :disabled="loading">
              Reset Password
            </v-btn>
          </v-card-actions>
        </v-card>
        <custom-snackbar></custom-snackbar>
      </v-col>
    </v-row>
  </v-container>
</section>

                         
                  </template> 
                  <script >
import { setTimeout } from 'timers'
import Individual from '@/modules/individual/models/Individual'
import ResetPassword from '@/modules/auth/views/ResetPassword.vue'

export default {
  name: 'IndividualResetPassword',
  extends: ResetPassword,
  data() {
    return {
      type: 'user',
      label: ''
    }
  },
  computed: {
    backgroundImage() {
      return this.bucketUrl + '/assets/background_landing-page.jpg'
    }
  },
  methods: {
    async submit() {
      let result = await this.$validator.validateAll()
      if (!result) {
        return // there are errors
      }
      try {
        let form = {
          id: this.id,
          password: this.password,
          password_confirmation: this.password_confirmation,
          token: this.token
        }
        this.loading = true

        await Individual.dispatch('resetPassword', {
          payload: form,
          axios: this.$axios
        })
        this.showSnackbar('Password successfully reset. Please, login now')
        setTimeout(() => {
          this.$router.push('/user/login')
        }, 3500)

        this.loading = false
      } catch (error) {
        this.loading = false
        if (error.status === 422) {
          this.showErrorSnackbar('One of the fields could not be validated.')
          return
        }
        this.showErrorSnackbar('Wrong username/password')
      }
    }
  }
}
</script>